import { Card, Link, PropsWithChildren, FC, Path} from 'external/react'
import Icon, { IconName } from 'external/fortawesome'
import { clsx } from 'external/clsx'

type HomeItemProps = {
    icon: IconName,
    label: string,
    to: string | Partial<Path>,
    className?: string
}

const HomeItem: FC<PropsWithChildren<HomeItemProps>> = (props) => {
    const {to, icon, label, children, className} = props
	return (
        <div className={clsx('col-xl-3 col-md-6 col-sm-6 mb-3', className)}>
            <Link to={to} className='text-decoration-none'>
                <Card className='shadow-sm text-center'>
                    <Card.Body className='mt-3'>
                        <Card.Title>
                            <Icon name={icon} className='c-default fa-3x' />
                        </Card.Title>
                        <Card.Text className='c-default fs-3'>
                            {label}
                        </Card.Text>
                        {children}
                    </Card.Body>
               </Card>
            </Link>
        </div>)
}

export {HomeItem as default}